import { c as _c } from "react/compiler-runtime";
import { RefObject } from "react";
import { MEMES_SEASON } from "@/enums";
import { CommonSelectItem } from "@/components/utils/select/CommonSelect";
import CommonDropdown from "@/components/utils/select/dropdown/CommonDropdown";
type SelectedType = MEMES_SEASON | null;
export default function UserPageCollectedFiltersSzn(t0) {
  const $ = _c(5);
  const {
    selected,
    containerRef,
    setSelected
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const labels = {
      [MEMES_SEASON.SZN1]: "SZN 1",
      [MEMES_SEASON.SZN2]: "SZN 2",
      [MEMES_SEASON.SZN3]: "SZN 3",
      [MEMES_SEASON.SZN4]: "SZN 4",
      [MEMES_SEASON.SZN5]: "SZN 5",
      [MEMES_SEASON.SZN6]: "SZN 6",
      [MEMES_SEASON.SZN7]: "SZN 7",
      [MEMES_SEASON.SZN8]: "SZN 8",
      [MEMES_SEASON.SZN9]: "SZN 9",
      [MEMES_SEASON.SZN10]: "SZN 10",
      [MEMES_SEASON.SZN11]: "SZN 11",
      [MEMES_SEASON.SZN12]: "SZN 12",
      [MEMES_SEASON.SZN13]: "SZN 13"
    };
    t1 = [{
      label: "All Seasons",
      value: null,
      key: "all"
    }, ...Object.values(MEMES_SEASON).map(value => ({
      label: labels[value],
      value,
      key: value
    }))];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const items = t1;
  let t2;
  if ($[1] !== containerRef || $[2] !== selected || $[3] !== setSelected) {
    t2 = <CommonDropdown items={items} filterLabel="Season" activeItem={selected} containerRef={containerRef} setSelected={setSelected} />;
    $[1] = containerRef;
    $[2] = selected;
    $[3] = setSelected;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}